import { RootState } from '@th-common/store/store';

export const selectors = {
  selectData: (state: RootState): string => state.common.data,
  isAuthenticated: (state: RootState): boolean | null => state.common.isAuthenticated,
};

